"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _videoRoom = require('web/selectors/videoRoom');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');
var _anonymousVideoRoomUserCache = require('web/services/anonymousVideoRoomUserCache'); var _anonymousVideoRoomUserCache2 = _interopRequireDefault(_anonymousVideoRoomUserCache);
var _videoRoom3 = require('web/services/videoRoom'); var _videoRoom4 = _interopRequireDefault(_videoRoom3);


var _IncompatibleBrowser = require('web/screens/VideoCall/IncompatibleBrowser'); var _IncompatibleBrowser2 = _interopRequireDefault(_IncompatibleBrowser);
var _Permissions = require('web/screens/VideoCall/Permissions'); var _Permissions2 = _interopRequireDefault(_Permissions);
var _OnCall = require('web/screens/VideoCall/OnCall'); var _OnCall2 = _interopRequireDefault(_OnCall);
var _Setup = require('web/screens/VideoCall/Setup'); var _Setup2 = _interopRequireDefault(_Setup);
var _PreCall = require('web/screens/VideoCall/PreCall'); var _PreCall2 = _interopRequireDefault(_PreCall);
var _Feedback = require('web/screens/VideoCall/Feedback'); var _Feedback2 = _interopRequireDefault(_Feedback);
var _InvalidRoomLink = require('web/components/VideoCall/InvalidRoomLink'); var _InvalidRoomLink2 = _interopRequireDefault(_InvalidRoomLink);
var _RoomSidebar = require('web/screens/VideoCall/segments/RoomSidebar'); var _RoomSidebar2 = _interopRequireDefault(_RoomSidebar);
var _Modals = require('web/components/VideoCall/Modals');
var _useClassState = require('./useClassState');

const ROUTING = {
  SETUP: 'ROUTE_SETUP',
  ONCALL: 'ROUTE_ONCALL',
  PRECALL: 'ROUTE_PRECALL',
  FEEDBACK: 'ROUTE_FEEDBACK',
}

const roomLoadStatuses = {
  LOADING: 'ROOM_LOADING',
  FAILED: 'ROOM_LOAD_FAILED',
  LOADED: 'ROOM_LOADED',
}























// Was a class inside connect(): memo keeps connect's props bail-out. The
// handlers keep stable identities (the screens below are memoised) and read
// the committed props and state through `latest`, as the class read
// `this.props`/`this.state`. State keeps class setState semantics, including
// the after-commit callback of the name submit.
const VideoCallRoot = (props) => {
  const {
    roomKey,
    onRoomLinkCopy, onRoomShare,
    openMobileMoreOptionsModal, openSettingsModal,
    isNetstatsModalOpen, openNetstatsModal, closeNetstatsModal,
    showNoticeBar, onCallJoinFailed,
  } = props

  // Not rendered, but connect() subscribed to it, so a change re-renders the
  // root as before.
  _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomLink)
  const arePermsGranted = _hooks.useAppSelector.call(void 0, _videoCall.selectArePermsGranted)
  const isBrowserCompatible = _hooks.useAppSelector.call(void 0, _videoCall.selectIsBrowserCompatible)

  // The state initialiser runs before the session is created, as the class
  // field initialisers did.
  const [state, setState, flushCallbacks] = _useClassState.useClassState(() => ({
    currentRoute: ROUTING.SETUP,
    prevRoute: ROUTING.PRECALL,

    anonymousUserName: _anonymousVideoRoomUserCache2.default.getName(),
    isNamePromptModalOpen: false,
    roomLoadStatus: roomLoadStatuses.LOADING,
  }))
  // SAFETY: an undefined route key is passed through, as the JS did.
  const [videoRoomSession] = _react.useState.call(void 0, () => new (0, _videoRoom4.default)(roomKey ))

  const latest = _react.useRef.call(void 0, { props, state })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { props, state }
    flushCallbacks()
  })

  const openNamePromptModal = _react.useCallback.call(void 0, () => setState({ isNamePromptModalOpen: true }), [setState])
  const closeNamePromptModal = _react.useCallback.call(void 0, () => setState({ isNamePromptModalOpen: false }), [setState])

  const navGoto = _react.useCallback.call(void 0, (route) => setState(s => ({
    currentRoute: route,
    prevRoute: s.currentRoute,
  })), [setState])

  const gotoCallSetup = _react.useCallback.call(void 0, () => navGoto(ROUTING.SETUP), [navGoto])
  const gotoPreCall = _react.useCallback.call(void 0, () => navGoto(ROUTING.PRECALL), [navGoto])
  const gotoCall = _react.useCallback.call(void 0, () => navGoto(ROUTING.ONCALL), [navGoto])
  const gotoFeedback = _react.useCallback.call(void 0, () => navGoto(ROUTING.FEEDBACK), [navGoto])
  const goBack = _react.useCallback.call(void 0, () => navGoto(latest.current.state.prevRoute), [navGoto])

  const handleGracefulExit = _react.useCallback.call(void 0, () => gotoFeedback(), [gotoFeedback])
  const handleForcefulExit = _react.useCallback.call(void 0, () => gotoPreCall(), [gotoPreCall])

  const startRoomSetup = _react.useCallback.call(void 0, () => {
    const { anonymousUserName: userName } = latest.current.state
    // SAFETY: only called with a name set ('' included), as in the JS.
    _actions2.default.updateAnonymousUser({ userName: userName  })
    // SAFETY: as above.
    videoRoomSession.startSetup({ RoomUserName: userName  })
  }, [videoRoomSession])

  const handleUserNameSubmit = _react.useCallback.call(void 0, (anonymousUserName) => {
    closeNamePromptModal()
    setState({ anonymousUserName }, startRoomSetup)
  }, [closeNamePromptModal, setState, startRoomSetup])

  // componentDidMount, with the props and state of the first render.
  _react.useLayoutEffect.call(void 0, () => {
    const { anonymousUserName } = latest.current.state
    const { roomKey: mountRoomKey } = latest.current.props

    // SAFETY: as above, an undefined route key is passed through.
    _actions2.default.setCurrentVideoRoomKey(mountRoomKey )
    // SAFETY: as above.
    _actions2.default.fetchVideoRoom(mountRoomKey )
      .then(() => setState({ roomLoadStatus: roomLoadStatuses.LOADED }))
      .catch(() => setState({ roomLoadStatus: roomLoadStatuses.FAILED }))

    if (!anonymousUserName && anonymousUserName !== '') { return openNamePromptModal() }

    startRoomSetup()
  }, [openNamePromptModal, setState, startRoomSetup])

  const renderRouting = () => {
    const { currentRoute } = state
    const { PRECALL, SETUP, ONCALL, FEEDBACK } = ROUTING

    switch (currentRoute) {
      case PRECALL: return (
        _react2.default.createElement(_PreCall2.default, {
          gotoCall: gotoCall,
          gotoCallSetup: gotoCallSetup,
          onRoomLinkCopy: onRoomLinkCopy,
          openNamePromptModal: openNamePromptModal,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}
        )
      )
      case SETUP: return (
        _react2.default.createElement(_Setup2.default, {
          gotoPreCall: gotoPreCall,
          goBack: goBack,
          onUserProblemPublish: videoRoomSession.publishProblem, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
        )
      )
      case ONCALL: return (
        _react2.default.createElement(_OnCall2.default, {
          onGracefulExit: handleGracefulExit,
          onForcefulExit: handleForcefulExit,
          onCallJoinFailed: onCallJoinFailed,
          showNoticeBar: showNoticeBar,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal,
          openSettingsModal: openSettingsModal,
          onRoomLinkCopy: onRoomLinkCopy,
          onRoomShare: onRoomShare,
          isNetstatsModalOpen: isNetstatsModalOpen,
          openNetstatsModal: openNetstatsModal,
          closeNetstatsModal: closeNetstatsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
        )
      )
      case FEEDBACK: return (
        _react2.default.createElement(_Feedback2.default, {
          gotoCall: gotoCall,
          onRoomLinkCopy: onRoomLinkCopy,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
        )
      )
    }

    return null
  }

  const renderRoomBody = () => {
    const { anonymousUserName, roomLoadStatus } = state

    if (!anonymousUserName && anonymousUserName !== '') return null
    if (!isBrowserCompatible) {
      return (
        _react2.default.createElement(_IncompatibleBrowser2.default, {
          onRoomLinkCopy: onRoomLinkCopy,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}
        )
      )
    }

    const isRoomLoaded = roomLoadStatus === roomLoadStatuses.LOADED
    const hasRoomLoadFailed = roomLoadStatus === roomLoadStatuses.FAILED
    if (!isRoomLoaded) {
      return hasRoomLoadFailed
        ? _react2.default.createElement(_InvalidRoomLink2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 211}} )
        : null
    }
    if (!arePermsGranted) {
      return (
        _react2.default.createElement(_Permissions2.default, {
          onRoomLinkCopy: onRoomLinkCopy,
          openMobileMoreOptionsModal: openMobileMoreOptionsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
        )
      )
    }

    return renderRouting()
  }

  const { isNamePromptModalOpen, anonymousUserName } = state
  const isOnCall = state.currentRoute === ROUTING.ONCALL

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "video-call--room", isOnCall && "video-call--wrapper-on-call"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
      ,  !isOnCall &&
        _react2.default.createElement(_RoomSidebar2.default, { onRoomLinkCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}} )
      
      , _react2.default.createElement('div', { className: "video-call--room-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}
        ,  renderRoomBody() 
        , _react2.default.createElement(_Modals.NamePromptModal, {
          // SAFETY: a null name is passed through as before (then no key).
          key: anonymousUserName ,
          isOpen: isNamePromptModalOpen,
          // SAFETY: as above.
          userName: anonymousUserName ,
          onProceed: handleUserNameSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, VideoCallRoot)
